import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	cancel: {
		id: 'project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.cancel',
		defaultMessage: 'Go back',
		description: 'Button text for staying on mapping screen',
	},
	titleStandard: {
		id: 'project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.title-standard',
		defaultMessage:
			'{count, plural, one {# column is not mapped} other {# columns are not mapped}}',
		description:
			'Warning modal header when user attempts to continue without mapping all columns to fields',
	},
	descriptionStandard: {
		id: 'project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.description-standard',
		defaultMessage:
			'Some columns from the CSV file are not mapped to Jira fields. To include them in the import, go back and map these columns to the appropriate Jira fields. Select the <b>All fields</b> dropdown for filtering options.',
		description:
			'Warning modal body when user attempts to continue without mapping all columns to fields',
	},
	excludeFromImport: {
		id: 'project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.exclude-from-import',
		defaultMessage: 'Exclude from Import',
		description: 'Button text for excluding columns and moving further',
	},
});
